<card name="Store groups table">
  <div card content>
    <smart-table [headers]="headers" [source]="source">
      <ng-template smartTableColumn="name" let-item>
        <td>
          <span class="font-weight-medium">{{ item.name }}</span>
        </td>
      </ng-template>

      <ng-template smartTableColumn="createdAt" let-item>
        <td>
          {{ item.name }}
        </td>
      </ng-template>

      <ng-template smartTableColumn="stores" let-item>
        <td>
          <ng-container *ngFor="let store of item.stores">
            {{ store }} <br>
          </ng-container>
        </td>
      </ng-template>
    </smart-table>
  </div>
</card>
